




































import { Component, Prop, Vue } from "@/shared/vuepack";
import { useFamilyStore } from "@/employer/store/family";
import {
  FamilyMember,
  FamilyMemberRelationship,
  familyMemberRelationshipMap,
  FamilyMemberStatus
} from "@/shared/types";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { lastFour as ssnLastFour } from "@/shared/ssn";
import _ from "lodash";
import AccountHolderWidgetBase from "@/employer/components/partner-ee-service/AccountHolderWidgetBase.vue";
import Pill from "@/shared/components/ui/Pill.vue";

interface DependentTableItem {
  id: number;
  name: string;
  dateOfBirth: string;
  ssn: string;
  relationship: string;
  isActive: boolean;
}

@Component({
  components: {
    AccountHolderWidgetBase,
    Pill
  }
})
export default class AccountHolderDependents extends Vue {
  familyStore = useFamilyStore();

  @Prop({ required: true })
  username: string;

  @Prop({ required: true })
  partnerId: number;

  get isLoading () {
    return this.familyStore.isLoading;
  }

  get isLoaded () {
    return this.familyStore.isLoaded;
  }

  get isFailed () {
    return this.familyStore.isFailed;
  }

  get hasData () {
    return this.isLoaded && this.dependents && this.dependents.length > 0;
  }

  get dependents (): DependentTableItem[] {
    const supportedValues = [FamilyMemberRelationship.Spouse, FamilyMemberRelationship.Dependent];
    const familyMembers = this.familyStore.familyMembers
      .filter(member => supportedValues.includes(member.relationship))
      .map(member => ({
        id: member.id,
        name: this.getName(member),
        dateOfBirth: formatMMddyyyyDateString(member.dateOfBirth),
        ssn: member.ssn ? ssnLastFour(member.ssn) : "",
        relationship: familyMemberRelationshipMap[member.relationship],
        isActive: member.status === FamilyMemberStatus.Active
      }));

    return _.sortBy(familyMembers, member => !member.isActive, member => member.name);
  }

  loadData () {
    this.familyStore.initialize({
      username: this.username,
      partnerId: this.partnerId
    });
  }

  getName (member: FamilyMember) {
    if (member.middleInitial) {
      return `${member.firstName} ${member.middleInitial} ${member.lastName}`;
    }

    return `${member.firstName} ${member.lastName}`;
  }
}
